import React, { Component } from 'react';

import {
  EuiIcon,
  EuiHeaderSectionItemButton,
  EuiListGroup,
  EuiListGroupItem,
  EuiPopover,
} from 'stable-eui';

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  onMenuButtonClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  closeMenu = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const items = [
      // {
      //   title: 'B-Logistics v1.5.0',
      // },
    ];
    const button = (
      <EuiHeaderSectionItemButton
        aria-controls="keyPadMenu"
        aria-expanded={this.state.isOpen}
        aria-haspopup="true"
        tabIndex={-1}
        aria-label="Apps menu with 1 new app"
        notification={items.length > 0 ? items.length : undefined}
        onClick={this.onMenuButtonClick}
      >
        <EuiIcon type="bell" size="m" />
      </EuiHeaderSectionItemButton>
    );

    return (
      <EuiPopover
        id="headerAppMenu"
        ownFocus
        button={button}
        isOpen={this.state.isOpen}
        anchorPosition="downRight"
        closePopover={this.closeMenu}
      >
        <EuiListGroup showToolTips>
          {items.map((item, index) => (
            <EuiListGroupItem
              key={index}
              onClick={() => { }}
              label={`${item.title}`}
              size="m"
            />
          ))}
        </EuiListGroup>
      </EuiPopover>
    );
  }
}
